import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './image/ctu_banner_btn.png';
var _hoisted_1 = {
  class: "swiper_box"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "ctu_swiper_text_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "jump_detail_btn"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "en_swiper_text_ctu"
}, "Tenacity in Neuroscience"), /*#__PURE__*/_createElementVNode("div", {
  class: "en_swiper_text_ctu"
}, "Innovate for Life")], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_BannerSwiper = _resolveComponent("BannerSwiper");

  var _component_Occupation = _resolveComponent("Occupation");

  var _component_Culture = _resolveComponent("Culture");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_BannerSwiper, {
    bannerList: $setup.bannerList
  }, {
    default: _withCtx(function () {
      return [_hoisted_2];
    }),
    _: 1
  }, 8, ["bannerList"]), _createVNode(_component_Occupation), _createVNode(_component_Culture)]);
}